
export const state = {
  isApiFetching: false,
  isAnimationLoading: false,
  formValues: {
    phone_number: null,
    address: null,
  },
  formErrors: {},
}

export const mutations = {
  SET_ADDRESS(state, payload) {
    state.formValues.address = payload
  },
  SET_ISAPIFETCHING(state, payload) {
    state.isApiFetching = payload
  },
  SET_ISANIMATIONLOADING(state, payload) {
    state.isAnimationLoading = payload
  },
  RESET_FORMERRORS(state) {
    state.formErrors = {}
  },
  RESET_LOADINGSTATE(state) {
    state.isApiFetching = false
    state.isAnimationLoading = false
  },
  RESET_ALLSTATE(state) {
    state.isApiFetching= false
    state.isAnimationLoading= false
    state.formErrors = {}
    state.formValues = {
      phone_number: null,
      address: null,
    }
  }
}

export const actions = {
  setAddress({ commit }, payload) {
    commit('SET_ADDRESS', payload)
  },
  setIsApiFetching({ commit }, payload) {
    commit('SET_ISAPIFETCHING', payload)
  },
  setIsAnimationLoading({ commit }, payload) {
    commit('SET_ISANIMATIONLOADING', payload)
  },
  resetFormErrors({ commit }) {
    commit('RESET_FORMERRORS')
  },
  resetLoadingState({ commit }) {
    commit("RESET_LOADINGSTATE")
  },
  resetAllState({ commit }) {
    commit('RESET_ALLSTATE')
  }
}